module.exports = __webpack_public_path__ + "img/typical.46aa2e0a.jpg";